"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const DetailPage_1 = __importDefault(require("./DetailPage"));
const HandoverPage_1 = __importDefault(require("./HandoverPage"));
const WeatherPage_1 = __importDefault(require("./WeatherPage"));
const Settings_1 = __importDefault(require("./Settings"));
const VideoPage_1 = __importDefault(require("./VideoPage"));
const DocumentPage_1 = __importDefault(require("./DocumentPage"));
const ProgressBar_1 = __importDefault(require("./ProgressBar"));
const helpers_1 = require("../../../../common/helpers/helpers");
const ImageOnlyPage_1 = __importDefault(require("./ImageOnlyPage"));
const weatherHelpers_1 = require("../../../../common/helpers/weatherHelpers");
const DSLinearContainer = styled_components_1.default.div `
  height: 100%;
  position: relative;

  .next-page-item {
    display: none;
  }

  background-color: ${props => props.theme.palette.mainAppColor.main};

  &.handover-background {
    background: linear-gradient(
      to top,
      ${props => props.theme.palette.colorAppBar.main} 0%,
      ${props => helpers_1.Helpers.lightenColor(props.theme.palette.colorAppBar.main, 70)} 100%
    );
  }

  &.weather-background {
    &.sunny {
      background: linear-gradient(330deg, #00416a, #d4f2ff);
    }
    &.rain {
      background: linear-gradient(to bottom right, rgba(174, 189, 194, 1), rgba(81, 90, 95, 1));
    }
    &.snow {
      background: linear-gradient(to bottom right, rgba(173, 192, 214, 1), rgba(173, 192, 214, 1));
    }
    &.night {
      background: linear-gradient(to bottom right, rgba(49, 83, 121, 1), rgba(0, 0, 0, 1));
    }
  }

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${(props) => `url(${props.backgroundImages.portrait} )`};

  @media (orientation: landscape) {
    background-image: ${(props) => `url(${props.backgroundImages.landscape} )`};
  }
`;
const DsFullScreenPlaceholder = styled_components_1.default.div `
  height: 100%;

  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  &.fullscreen-container {
    padding: 0px 5vmin 11vmin;
    background-color: transparent;
    transform: scale(1.1);
    filter: blur(20px);
  }

  &.fullscreen-full-image {
    background-size: contain;
    width: 100%;
    top: 0;
    background-position: center;
  }

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  background-image: ${(props) => `url(${props.backgroundImages.portrait} )`};

  @media (orientation: landscape) {
    background-image: ${(props) => `url(${props.backgroundImages.landscape} )`};
  }
`;
const defaultSettings = {
    stopSlideShow: false,
    stopAnimationsInSlide: false,
    changeSlideInterval: 8000,
    fadeInContentTime: 1500,
    speed: 1, // 1 = normal speed, 2 = 2 * normal speed, etc
};
const SlideShow = (props) => {
    const [activeIndex, setActiveIndex] = (0, react_1.useState)(0);
    // we want to interrupt slides to break all ongoing animations so that the next slide animation starts fresh
    const [interruptSlides, setSlideInteruption] = (0, react_1.useState)(false);
    const [speed, setSpeed] = (0, react_1.useState)(defaultSettings.speed);
    const [stopSlideShow, toggleSlideShow] = (0, react_1.useState)(defaultSettings.stopSlideShow);
    const [stopAnimations, toggleAnimations] = (0, react_1.useState)(defaultSettings.stopAnimationsInSlide);
    const [currentSlideDuration, setCurrentSlideDuration] = (0, react_1.useState)(defaultSettings.changeSlideInterval);
    const [reloadFlag, setReloadFlag] = (0, react_1.useState)(false);
    const handleReload = () => setReloadFlag(prev => !prev);
    const showSettings = props.controls;
    const arrayOfSelectedLocale = typeof props.selectedLocale === 'string' ? Array(props.selectedLocale) : props.selectedLocale;
    const slides = (0, react_1.useMemo)(() => {
        const translatedSlides = [];
        props.slides.forEach(slide => {
            if (slide.type === 'document') {
                translatedSlides.push(slide);
                return;
            }
            if (slide.type === 'handover') {
                const handoverSlides = [];
                arrayOfSelectedLocale.forEach(item => {
                    handoverSlides.push({
                        type: 'handover',
                        languageSelected: item,
                        dsExclusive: false,
                    });
                });
                translatedSlides.push(...handoverSlides);
                return;
            }
            if (slide.type === 'weather') {
                const weatherSlides = arrayOfSelectedLocale.map(selectedLanguage => Object.assign({}, slide, { languageSelected: selectedLanguage }));
                translatedSlides.push(...weatherSlides);
                return;
            }
            const hasVideos = slideHasVideo(slide);
            const hasImage = slide.images && slide.images.length > 0;
            const isFullscreen = slide.dsFullScreen;
            if (isFullscreen) {
                if (!hasVideos && !hasImage) {
                    return;
                }
                if (!hasVideos) {
                    translatedSlides.push(slide);
                    return;
                }
                if (hasVideos && !slide.switchLanguages) {
                    translatedSlides.push(slide);
                    return;
                }
                if (hasVideos && slide.switchLanguages) {
                    const helper = [];
                    slide.switchLanguages.forEach(iteratedSlide => {
                        helper.push(...splitVideoSlide(iteratedSlide, true));
                    });
                    translatedSlides.push(...helper);
                    return;
                }
            }
            if (slide.switchLanguages) {
                const helper = [];
                slide.switchLanguages.forEach(iteratedSlide => {
                    const showOnlyVideo = slide.dsFullScreen || (hasVideos && !hasImage);
                    helper.push(...splitVideoSlide(iteratedSlide, showOnlyVideo));
                });
                translatedSlides.push(...helper);
            }
            else {
                const showOnlyVideo = hasVideos && !hasImage;
                translatedSlides.push(...splitVideoSlide(slide, showOnlyVideo));
            }
        });
        if (showSettings) {
            console.log('slides', translatedSlides);
        }
        return translatedSlides;
    }, [props.slides]);
    (0, react_1.useEffect)(() => {
        if (slides.length === 1) {
            handleReload();
        }
    }, [slides]);
    // modifies default settings based on speed
    const settings = {
        stopSlideShow,
        stopAnimationsInSlide: stopAnimations,
        changeSlideInterval: slides.length === 1 ? 600000 / speed : defaultSettings.changeSlideInterval / speed,
        fadeInContentTime: defaultSettings.fadeInContentTime / speed,
        speed, // 1 = normal speed, 2 = 2*normal speed, etc
    };
    (0, react_1.useEffect)(() => {
        setSlideInteruption(true);
        setTimeout(() => {
            setSlideInteruption(false);
        }, 0);
    }, [activeIndex]);
    const openNextSlide = () => {
        if (!(activeIndex + 1 >= slides.length)) {
            setActiveIndex(activeIndex + 1);
        }
        else {
            props.updateStore('reloadNeeded', true);
            setActiveIndex(0);
        }
        return true;
    };
    const getSlideAtIndex = index => {
        const slideData = slides[index];
        const itemHasVideo = slideHasVideo(slideData);
        if (slideData.type === 'handover') {
            return (react_1.default.createElement(HandoverPage_1.default, { content: slideData, openNextSlide: openNextSlide, settings: settings, setCurrentSlideDuration: setCurrentSlideDuration }));
        }
        if (slideData.type === 'weather') {
            return (react_1.default.createElement(WeatherPage_1.default, { content: slideData, openNextSlide: openNextSlide, settings: settings, setCurrentSlideDuration: setCurrentSlideDuration }));
        }
        if (slideData.type === 'document') {
            return (react_1.default.createElement(DocumentPage_1.default, { content: slideData, openNextSlide: openNextSlide, settings: settings, setCurrentSlideDuration: setCurrentSlideDuration }));
        }
        if (itemHasVideo) {
            return react_1.default.createElement(VideoPage_1.default, { content: slideData, openNextSlide: openNextSlide, settings: settings });
        }
        if (slideData.dsFullScreen === true) {
            // This means that the slide is image only
            return (react_1.default.createElement(ImageOnlyPage_1.default, { content: slideData, openNextSlide: openNextSlide, settings: settings, setCurrentSlideDuration: setCurrentSlideDuration }));
        }
        return (react_1.default.createElement(DetailPage_1.default, { key: slides.length === 1 ? reloadFlag : undefined, content: slideData, openNextSlide: openNextSlide, settings: settings, setCurrentSlideDuration: setCurrentSlideDuration }));
    };
    const getNextPageBackgroundImage = () => {
        const nextPage = slides[activeIndex + 1];
        if (!nextPage) {
            return null;
        }
        const itemHasVideo = slideHasVideo(nextPage);
        if (itemHasVideo || nextPage.type === 'handover' || nextPage.type === 'weather') {
            return null;
        }
        const isLandscape = window.innerWidth > window.innerHeight;
        if (nextPage.dsFullScreen && nextPage.images[0]) {
            return nextPage.images[0].original;
        }
        if (nextPage.images[0]) {
            return isLandscape ? nextPage.images[0]['2:1'].XXL : nextPage.images[0]['10:10'].XXL;
        }
        return null;
    };
    const imagesTypes = ['image/jpeg', 'image/png'];
    const getNextPageDocument = () => {
        const nextPage = slides[activeIndex + 1];
        if (!nextPage) {
            return null;
        }
        if (nextPage.type === 'document') {
            if (imagesTypes.includes(nextPage.contentType)) {
                const image = new Image();
                image.src = nextPage.dataUrl;
                return react_1.default.createElement("img", { className: "next-page-item", src: nextPage.dataUrl, alt: "next-page-document" });
            }
            return (react_1.default.createElement("object", { className: "next-page-item", data: nextPage.dataUrl, type: nextPage.contentType, "aria-label": nextPage.title }));
        }
        return null;
    };
    if (props.slides.length === 0)
        return null;
    // used to trick the next slide cover image into loading and being cached so no janky image loading happens on slide change
    const nextPageBackgroundImg = getNextPageBackgroundImage();
    const nextPageDocument = getNextPageDocument();
    const activePage = getSlideAtIndex(activeIndex);
    const previousSlideData = slides[activeIndex - 1];
    const activeSlideData = slides[activeIndex];
    const showBackgroundOnFadeIn = pageHasBackgroundImage(previousSlideData);
    const previousPageIsHandoverClass = previousSlideData && previousSlideData.type === 'handover' ? 'handover-background' : '';
    const previousPageIsWeatherClass = previousSlideData && previousSlideData.type === 'weather' ? 'weather-background' : '';
    const weatherTypeClass = previousPageIsWeatherClass ? (0, weatherHelpers_1.getWeatherClass)(props.weatherData, props.venue) : '';
    return (react_1.default.createElement(DSLinearContainer, { className: `ds-linear-container ${previousPageIsHandoverClass} ${previousPageIsWeatherClass} ${weatherTypeClass}`, backgroundImages: {
            landscape: showBackgroundOnFadeIn &&
                previousSlideData.images &&
                previousSlideData.images[0] &&
                previousSlideData.images[0]['2:1'] &&
                previousSlideData.images[0]['2:1'].XXL,
            portrait: showBackgroundOnFadeIn &&
                previousSlideData.images &&
                previousSlideData.images[0] &&
                previousSlideData.images[0]['10:10'] &&
                previousSlideData.images[0]['10:10'].XXL,
        } },
        previousSlideData && previousSlideData.dsFullScreen && (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(DsFullScreenPlaceholder, { className: "fullscreen-container", backgroundImages: {
                    landscape: showBackgroundOnFadeIn &&
                        previousSlideData.images &&
                        previousSlideData.images[0] &&
                        previousSlideData.images[0].original,
                    portrait: showBackgroundOnFadeIn &&
                        previousSlideData.images &&
                        previousSlideData.images[0] &&
                        previousSlideData.images[0].original,
                } }),
            react_1.default.createElement(DsFullScreenPlaceholder, { className: "fullscreen-full-image", backgroundImages: {
                    landscape: showBackgroundOnFadeIn &&
                        previousSlideData.images &&
                        previousSlideData.images[0] &&
                        previousSlideData.images[0].original,
                    portrait: showBackgroundOnFadeIn &&
                        previousSlideData.images &&
                        previousSlideData.images[0] &&
                        previousSlideData.images[0].original,
                } }))),
        !interruptSlides && activePage,
        interruptSlides && activePage,
        showSettings && (react_1.default.createElement(Settings_1.default, { slides: slides, activeIndex: activeIndex, setActiveIndex: setActiveIndex, speed: speed, setSpeed: setSpeed, toggleSlideShow: toggleSlideShow, stopSlideShow: stopSlideShow, stopAnimations: stopAnimations, toggleAnimations: toggleAnimations })),
        nextPageBackgroundImg && (react_1.default.createElement("img", { className: "next-page-item", alt: "next-page-background", src: nextPageBackgroundImg })),
        nextPageDocument,
        react_1.default.createElement(ProgressBar_1.default, { numberOfSlides: slides.length, slideDuration: currentSlideDuration, currentSlideIndex: activeIndex, currentSlideHasVideo: activeSlideData.videos && activeSlideData.videos.length > 0 })));
};
function slideHasVideo(slideData) {
    // check this for more info about brightcove HM-2210
    const isBrightcoveWithWrongUrl = slideData.videos &&
        slideData.videos.length > 0 &&
        (slideData.videos[0].video_type === 'brightcove' || slideData.videos[0].videoType === 'brightcove') &&
        !slideData.videos[0].value.includes('players.brightcove.net');
    const itemHasVideo = slideData.videos && slideData.videos.length > 0 && !isBrightcoveWithWrongUrl;
    return itemHasVideo;
}
function splitVideoSlide(slide, showOnlyVideo = false) {
    const videoSlide = slide;
    const textSlide = Object.assign({}, slide, { videos: [] });
    const isVideoSlide = slideHasVideo(slide);
    if (showOnlyVideo) {
        return [videoSlide];
    }
    if (!isVideoSlide) {
        return [slide];
    }
    return [textSlide, videoSlide];
}
function pageHasBackgroundImage(slideData) {
    if (!slideData) {
        return false;
    }
    const itemHasVideo = slideHasVideo(slideData);
    if (itemHasVideo) {
        return false;
    }
    if (slideData.type === 'handover' || slideData.type === 'weather' || slideData.type === 'document') {
        return false;
    }
    if (slideData.dsFullScreen) {
        return true;
    }
    return true;
}
const mapStoreToProps = store => ({
    weatherData: store.getValue('weather'),
    slides: store.getValue('slides'),
    venue: store.getValue('venue'),
    selectedLocale: store.getValue('urlSpecifiedLocale'),
    controls: store.getValue('controls'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(SlideShow);
